import React, { useState, useEffect } from 'react';
import authService from '../services/authService';
import aes from '../utils/aes';
import { isValidToken, setSession, decodeJwt } from '../utils/jwt';

const AuthContext = React.createContext();

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState();
    const [isInit, setIsInit] = useState(false);

    useEffect(() => {
        const initialize = () => {
            const accessToken = localStorage.getItem("accessToken");
            const isValid = isValidToken(accessToken || '');
            if (isValid) {
                setSession(accessToken);
                setLoginUser(accessToken);
            }
            setIsInit(true);
        };

        initialize();
    }, []);

    const signIn = async (email, password) => {
        const response = await authService.login(email, aes.encrypt(password));
        if (response && response.code === 200) {
            const { token } = response.value;
            setSession(token);
            return setLoginUser(token);
        }

        throw (response?.message);
    };

    const signInByAuthCode = async (authCode) => {
        const response = await authService.loginByAuthCode(authCode);
        if (response && response.code === 200) {
            const { token } = response.value;
            setSession(token);
            return setLoginUser(token);
        }

        throw (response?.message);
    };

    const signOut = async () => {
        setSession(null);
        setUser(null);
    };

    const setLoginUser = (accessToken) => {
        const jwtPayload = decodeJwt(accessToken);
        const currentUser = { id: jwtPayload.id, email: jwtPayload.email, firstName: jwtPayload.firstName, lastName: jwtPayload.lastName, role: jwtPayload.userRole };
        setUser(currentUser);
        return currentUser
    }

    return (
        <AuthContext.Provider
            value={{ user, isInit, signIn, signInByAuthCode, signOut }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export {
    AuthContext,
    AuthProvider
}